import { Button } from "@/components/ui/Button";

export const ErrorFallback = () => {
  return (
    <div
      className="flex h-dvh w-screen flex-col items-center justify-center gap-y-6 bg-white"
      role="alert"
    >
      <h2 className="text-lg font-semibold text-chorus-black-300">
        Ooops, something went wrong :(
      </h2>
      <Button
        variant="secondary"
        onClick={() => window.location.assign(window.location.origin)}
      >
        Refresh
      </Button>
    </div>
  );
};
